<script setup lang="ts">
  import { useTemplateRef } from 'vue'
  import {
    Button,
    ModalSection,
    ModalSectionHeader,
    ModalSectionHeaderTitle,
    ModalSectionHeaderDescription
  } from '@gat-ship/vue-components'
  import { IconPlus } from '@gat-ship/icons'
  import {
    EstimatedTimeNamesList,
    EstimatedTimeNamesProvider
  } from '@gat-ship/estimated-time-names'

  const list =
    useTemplateRef<InstanceType<typeof EstimatedTimeNamesList>>('list')

  function openAdd() {
    list.value?.openAdd()
  }
</script>

<template>
  <EstimatedTimeNamesProvider>
    <!-- pt-3 offsets the modal's -mt-3 under-fade pull so the header and
         add button start below the fade; once scrolled, content still
         slides under it. pb-5 keeps the last row off the modal edge. -->
    <div class="flex flex-col gap-6 pb-5 pt-3">
      <ModalSection>
        <div class="flex items-start justify-between gap-4">
          <ModalSectionHeader class="pt-1">
            <ModalSectionHeaderTitle>
              Estimated time names
            </ModalSectionHeaderTitle>
            <ModalSectionHeaderDescription>
              Approximate time-of-day labels used by ETA and ETD fields when an
              exact clock time is not known.
            </ModalSectionHeaderDescription>
          </ModalSectionHeader>
          <Button class="shrink-0" @click="openAdd">
            <IconPlus class="size-4" />
            Add time name
          </Button>
        </div>
        <EstimatedTimeNamesList ref="list" />
      </ModalSection>
    </div>
  </EstimatedTimeNamesProvider>
</template>
